<template>
  <div
    class="siftConditions"
    v-if="searchSift && showsiftConditions"
    :class="showsiftConditions ? 'bottom-border' : ''"
  >
    <select-row
      v-for="(item, index) in typeList.slice(0, 3)"
      :key="index"
      :data="searchSift[item]"
      :type="item"
      :label="siftName[item]"
      @input="controler"
    ></select-row>
    <template v-if="isShowMore">
      <select-row
        v-for="(item, index) in typeList.slice(3)"
        :key="index + 3"
        :data="searchSift[item]"
        :type="item"
        :label="siftName[item]"
        @input="controler"
      ></select-row>
    </template>

    <!-- <div class="siftMore" @click="showMore()" v-if="typeList && typeList.length > 3"><span class="siftMore__text">{{isShowMore ? '收起筛选' : '更多筛选'}}</span><img src="//res11.xesimg.com/www/img/arrow-down.png" :class="{rotate:isShowMore === true}"></div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SelectRow from './SelectRow'
export default {
  name: 'siftConditions',
  props: ['isShowMore'],
  data() {
    return {
      // siftNames: searchSift.names,
      // searchSift: searchSift.sift,
      // showsiftConditions: true,
      // isShowMore: false
    }
  },
  components: {
    SelectRow
  },
  mounted() {},
  computed: {
    ...mapState({
      searchSift: state => state.SearchPage.searchSift,
      siftName: state => state.SearchPage.siftName,
      nameSort: state => state.SearchPage.nameSort,
      chooseSift: state => state.SearchPage.chooseSift,
      dataExpTag: state => state.SearchPage.dataExpTag
    }),
    typeList() {
      if (
        this.searchSift &&
        this.searchSift.constructor === Object &&
        Object.keys(this.searchSift).length > 0
      ) {
        const typeArr = Object.keys(this.searchSift)
        const sortArr =
          this.nameSort &&
          this.nameSort.filter(item => {
            return typeArr.indexOf(item) > -1
          })
        // console.log('===sortArr====', sortArr)
        return sortArr
      }
      return []
    },
    keyword() {
      return this.$route.query.keyword
    },
    showsiftConditions() {
      if (this.searchSift.constructor === Array && this.searchSift.length < 1) {
        return false
      }
      if (
        this.searchSift.constructor === Object &&
        Object.keys(this.searchSift).length < 1
      ) {
        return false
      }
      return true
    }
  },
  watch: {
    keyword() {
      this.isShowMore = false
    }
  },
  methods: {
    controler(data, event) {
      this.updataRoute(data, event)
    },
    updataRoute(data, event) {
      const routeInfo = this.routeInfo(data)
      this.xesLog('click', data, routeInfo, event)
      this.$router.replace(routeInfo)
    },
    routeInfo(data) {
      const currentQuery = {}
      const { query } = this.$route
      const newObj = {}
      newObj[data.type] = data.data
      const key = data.type
      currentQuery[key] = data.data.id
      currentQuery.flag = 2
      const chooseQuery = this.dealBreadFilItem(this.chooseSift)
      return {
        name: 'search',
        query: { ...chooseQuery, ...query, ...currentQuery }
      }
    },
    dealBreadFilItem(obj) {
      if (obj) {
        const newObj = {}
        for (let key in obj) {
          newObj[key] = obj[key].id
        }
        return newObj
      }
      return null
    },
    showMore(value) {
      console.log('====value=====', value)
      this.isShowMore = value
    },
    xesLog(eventName, data, routeInfo, event) {
      const clickIdTypes = {
        grades: '1.4.19',
        subjects: '1.4.20',
        difficulties: ' 1.4.21',
        termIds: '1.4.22',
        timeType: '1.4.23',
        timeSlot: '1.4.24',
        liveTypeIds: '1.4.25',
        versions: '1.4.26',
        type: '1.4.30'
      }
      const clickId = clickIdTypes[data.type]
      const XESLog = new this.$XESLog({
        key: `xeslog-searchPageSelected-${data.type}`,
        clickid: clickId,
        choosedid: data.data.id,
        choosedoption: this.chooseSift,
        sorttype: this.$route.query.sort ? this.$route.query.sort : 1,
        setgradeid: this.$store.state.cookies.userGrade,
        curgradeid: this.$store.state.cookies.currentGrade,
        query: this.$route.query.keyword,
        exp_tag: this.dataExpTag
      })
      XESLog.push({ eventname: eventName, target: event.target }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
.siftConditions {
  background: #fff;
  padding: 28px 28px 8px 28px;
  margin-bottom: 30px;
  font-size: 13px;
}
.siftMore {
  width: 77px;
  height: 22px;
  color: #999999;
  font-size: 12px;
  border: solid 1px #cccccc;
  cursor: pointer;
  padding: 0 8px;
  box-sizing: border-box;
  span {
    display: inline-block;
    vertical-align: middle;
    line-height: 20px;
  }
  img {
    display: inline-block;
    margin-left: 3px;
    vertical-align: middle;
    width: 8px;
    height: 5px;
    transition: all 0.2s;
  }
  .rotate {
    transform: rotate(180deg);
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/SearchPage/components/SiftConditions.vue